import { render, staticRenderFns } from "./LocalDNSNodeForm.vue?vue&type=template&id=5451715e&scoped=true"
import script from "./LocalDNSNodeForm.vue?vue&type=script&lang=js"
export * from "./LocalDNSNodeForm.vue?vue&type=script&lang=js"
import style0 from "./LocalDNSNodeForm.vue?vue&type=style&index=0&id=5451715e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451715e",
  null
  
)

export default component.exports